import React, { PropsWithChildren } from 'react';

import { Menu } from './Menu';
import { BaseProps, RefOrUndefined } from './Types';

function constructToolbar(
  { className, ...props }: PropsWithChildren<BaseProps>,
  ref: RefOrUndefined<HTMLDivElement>
) {
  return <Menu {...props} ref={ref} className={className} />;
}

export const Toolbar = React.forwardRef(constructToolbar);
